import React from 'react';
import { getAPI, postAPI } from '../utils/APIUtils';
import { downloadData, uploadData } from 'aws-amplify/storage';

import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import DownloadIcon from '@mui/icons-material/Download';
import SendIcon from '@mui/icons-material/Send';

type Props = {
  accountid: string;
  idid: string;
  completeActTypeAddtion: boolean;
  handleCommit: (fileName: string) => void;
  setCompleteActTypeAddtion: (completeActTypeAddtion: boolean) => void;
  setLoading: (loading: boolean) => void;
};

interface UploadFile {
  fileName: string,
  fileObj?: any;
};

export const ActTypeUpdatePanel: React.FC<Props> = (props) => {

  const [subDialog, setSubDialog] = React.useState(false);
  const openSubDialog = Boolean(subDialog);
  const closeSubDialog = () => setSubDialog(false);
  const [subMessage, setSubMessage] = React.useState<string>('');

  const downloadFormLGWAN = async (path: string) => {
    const apiurl = `/tempfile?path=private/${props.idid}/${path}`;
    const json = await getAPI(apiurl);
    const realdownloadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.downloadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.downloadUrl;

    const file = await fetch(realdownloadurl);
    const blob = await file.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const downloadForm = async (path: string) => {
    //const file = await Storage.get(path, { level: 'private' });
    const downloadTask = await downloadData({
      path: `private/${props.idid}/${path}`,
    });
    const { body } = await downloadTask.result;
    const blob = new Blob([await body.blob()]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement('a');
    link.href = url;
    const filename = path.split('/').pop();
    link.setAttribute('download', filename ? filename : 'noname');
    document.body.appendChild(link);
    link.click();
  };

  const handleDownload = async () => {
    props.setLoading(true);

    const url = `/acttype?accountid=${props.accountid}&idid=${props.idid}`;

    try {
      const json = await getAPI(url);
      const tmp: string = json.outPath;
      const newOutPath = tmp.replace(/private\/.*?\//, '');

      if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        downloadFormLGWAN(newOutPath);
      } else {
        downloadForm(newOutPath);
      }

    } catch (e) {
      // エラー
      console.log(e);
    }

    props.setLoading(false);
  };

  const [newUploadFile, setNewUploadFile] = React.useState<UploadFile>({ fileName: '', fileObj: '' });
  const selectedFile = (e) => {
    if (!e.target.files[0]) return;
    // ファイル形式チェック（json）
    const exts = ['json'];
    const ext = e.target.files[0].name.split('.').pop().toLowerCase();
    if (exts.indexOf(ext) === -1) {
      // タイプエラー
      setSubMessage('登録可能なファイル形式は［json］です。');
      setSubDialog(true);
      e.target.value = '';
      return;
    }

    const file = e.target.files[0];
    // ファイル名に日本語が含まれるとうまくいかないため、仮の名前に置き換える
    const newName = '' + new Date().getTime() + '_Type.' + file.name.split('.').pop();
    setNewUploadFile({ fileName: newName, fileObj: file });
    e.target.value = '';
  };
  const handleRemoveFile = () => {
    setNewUploadFile({ fileName: '', fileObj: '' });
  };
  const createUploadFileItem = (completeActTypeAddtion: boolean) => {
    const newFileObj = newUploadFile && newUploadFile.fileObj ? (
      <>
        <label style={{ 'margin': 10 }}>{newUploadFile && newUploadFile.fileObj.name}</label>
        <Button color="secondary" variant='outlined' component='span' onClick={handleRemoveFile}>Cancel</Button>
      </>
    ) : '';

    return (
      <>
        <span style={{ marginLeft: '10px' }}>
          <input type='file' id={'file-input'} style={{
            opacity: 0,
            appearance: 'none',
            position: 'absolute',
          }} onChange={selectedFile} />
          <label htmlFor={'file-input'}>
            <Button color="secondary" variant='outlined' component='span'>ファイルを選択</Button>
          </label>
          {newFileObj}
          <br />
        </span>
      </>
    );
  }

  const handleCommit = async () => {
    if (newUploadFile && newUploadFile.fileObj) {
      props.setLoading(true);

      // await Storage.put(newUploadFile.fileName, newUploadFile.fileObj, {
      //   level: 'private',
      //   contentType: 'text/plain'
      // });
      if (process.env.REACT_APP_LGWAN && process.env.REACT_APP_LGWAN === 'LG-WAN') {
        const apiurl = `/tempfile`;
        const options = {
          path: `private/${props.idid}/${newUploadFile.fileName}`,
          contenttype: newUploadFile.fileObj.type,
        };
        const json = await postAPI(apiurl, options);
        const realuploadurl = (process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT && process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT) ? json.uploadUrl.replace(process.env.REACT_APP_LGWAN_S3_VPC_ENDPOINT, process.env.REACT_APP_LGWAN_S3_REVERSE_ENDPOINT) : json.uploadUrl;

        const uploadResponse = await fetch(realuploadurl, {
          method: 'PUT',
          body: newUploadFile.fileObj,
          headers: {
            'Content-Type': newUploadFile.fileObj.type,
          },
        });

        if (!uploadResponse.ok) {
          console.error('アップロード失敗', uploadResponse.status, uploadResponse.statusText);
        }

      } else {
        await uploadData({
          path: `private/${props.idid}/${newUploadFile.fileName}`,
          data: newUploadFile.fileObj,
        });
      }

      props.handleCommit(newUploadFile.fileName);
      setNewUploadFile({ fileName: '', fileObj: '' });
    } else {
      setSubMessage('種別設定ファイルを指定して下さい。');
      setSubDialog(true);
    }
    return;
  };
  const closeCompleteActTypeAddtionDialog = () => {
    props.setCompleteActTypeAddtion(false);
    setNewUploadFile({ fileName: '', fileObj: '' });
  };

  const createCommitButton = () => {
    return (
      <Button variant="contained" color={'secondary'} endIcon={<SendIcon />} disabled={!(newUploadFile && newUploadFile.fileObj)} onClick={handleCommit}>
        登録
      </Button>
    );
  };

  return (
    <>
      <Typography variant="body1" component="span">現在の設定内容をダウンロード</Typography>
      <Tooltip title="ダウンロード">
        <IconButton size={'large'} sx={{
          color: (theme) => theme.palette.secondary.main,
          position: 'relative',
          left: 5,
        }} edge="end" aria-label="enforcedate" onClick={handleDownload}>
          <DownloadIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
      <br />
      <br />
      <Typography variant="body1" component="span">種別設定ファイルを指定して登録</Typography>
      <br />
      {createUploadFileItem(props.completeActTypeAddtion)}
      <br />
      {createCommitButton()}
      <Dialog
        open={props.completeActTypeAddtion}
        keepMounted
        onClose={closeCompleteActTypeAddtionDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">追加処理結果確認</DialogTitle>
        <DialogContent>
          <Typography>{'種別の更新処理が完了しました。'}</Typography>
          <Typography>{'ダウンロードされたファイルから処理結果をご確認ください。'}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeCompleteActTypeAddtionDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openSubDialog}
        keepMounted
        onClose={closeSubDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">エラー</DialogTitle>
        <DialogContent>
          <Typography>{subMessage}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeSubDialog} color="primary">
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};